import React from 'react';
import { MessageSquare, UserRound } from 'lucide-react';
import ReplyEditor from './ReplyEditor';
import StarRating from './StarRating';

const formatDate = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
};

const ReviewCard = ({ review, storeName, onReplySave, isReplySaving }) => {
  const serviceLabel = review.serviceName || review.serviceUuid || '';
  const tags = Array.isArray(review.tags) ? review.tags : [];
  const hasReply = Boolean(review.merchantReply);
  const sentiment = Number(review.rating) >= 4 ? 'positive' : Number(review.rating) <= 2 ? 'critical' : 'neutral';
  const sentimentLabel = sentiment === 'positive' ? 'Positive' : sentiment === 'critical' ? 'Critical' : 'Neutral';
  const customerLabel = review.customerPhoneMasked || review.appointmentUuid || '';
  return (
    <article className={hasReply ? 'review-card' : 'review-card review-card--awaiting'}>
      <div className="review-card__avatar" aria-hidden="true">
        <UserRound size={18} />
      </div>

      <div className="review-card__body">
        <div className="review-card__head">
          <div className="review-card__identity">
            <div className="review-card__rating">
              <StarRating value={review.rating} />
              <span className={`review-card__sentiment review-card__sentiment--${sentiment}`}>{sentimentLabel}</span>
              {customerLabel && <span className="review-card__customer">{customerLabel}</span>}
            </div>
            <div className="review-card__service-row">
              {serviceLabel && <span className="review-card__service">{serviceLabel}</span>}
              {Array.isArray(review.serviceNames) && review.serviceNames.length > 1 && (
                <span className="review-card__service-more">
                  +{review.serviceNames.length - 1} more service{review.serviceNames.length === 2 ? '' : 's'}
                </span>
              )}
            </div>
          </div>

          <div className="review-card__status">
            <span className="review-card__date">{formatDate(review.createdAt)}</span>
            <span className={hasReply ? 'review-card__reply-status review-card__reply-status--done' : 'review-card__reply-status review-card__reply-status--awaiting'}>
              {hasReply ? 'Responded' : 'Awaiting reply'}
            </span>
          </div>
        </div>

        {review.comment && <p className="review-card__comment">{review.comment}</p>}
        {tags.length > 0 && (
          <div className="review-card__tags">
            {tags.map((tag) => (
              <span key={tag} className="review-card__tag">{tag}</span>
            ))}
          </div>
        )}
        <ReplyEditor
          review={review}
          storeName={storeName}
          onSave={onReplySave}
          isSaving={isReplySaving}
          icon={<MessageSquare size={14} />}
        />
      </div>
    </article>
  );
};

export default ReviewCard;
